import React from 'react';

export default props => (
    <svg viewBox="0 0 38 38" {...props}>
        <path fill="#FFF"
              d="M23.5 19a4.5 4.5 0 0 0-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 28 19c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-14.73-9L10 11.27 14.73 16H10v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L26.73 28 28 26.73l-9-9L11.27 10zM19 11l-2.09 2.09L19 15.18V11z"/>
    </svg>
);